module.exports = __webpack_public_path__ + "media/images/pharmacy_logo-d963d5d50b2d8ccbdda4dc72d67db275.png";